import {Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output} from "@angular/core";
import {FUIChromeControlsService} from "../../chrome-controls.service";
import {FUIChromeControlComponent} from "../chrome-control.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {Subscription} from "rxjs";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    selector: "fui-chrome-control-dropdown",
    templateUrl: "./chrome-control-dropdown.component.html",
    styleUrls: ["./chrome-control-dropdown.component.scss"]
})
export class FUIChromeControlDropdownComponent extends FUIChromeControlComponent implements OnInit {
    @Input() label: string;
    @Input() align: string = "right";
    @Output() onActive: EventEmitter<boolean> = new EventEmitter<boolean>();
    @HostBinding("class.align-left") get alignLeft() {
        return this.align === "left";
    }
    @HostBinding("class.align-center") get alignCenter() {
        return this.align === "center";
    }
    @HostBinding("class.align-right") get alignRight() {
        return this.align === "right";
    }

    private subscriptions: Subscription = new Subscription();
    mainTopPosition: string;

    constructor(private chromeControlsService: FUIChromeControlsService,
                private eventsService: FUIEventsService,
                private elementRef: ElementRef) {
        super();
    }

    override ngOnInit(): void {
        this.mainTopPosition = (this.elementRef.nativeElement.getBoundingClientRect().y + this.elementRef.nativeElement.getBoundingClientRect().height) + "px";

        this.chromeControlsService.generateId().then((id) => {
            this.id = id;

            this.subscriptions.add(this.chromeControlsService.activeControl$.subscribe(
                (id) => {
                    if (id) {
                        if (this.id == id) {
                            this.active = true;
                            this.conflict = false;
                        }
                        else {
                            this.active = false;
                            this.conflict = true;
                        }
                    }
                    else {
                        this.active = false;
                        this.conflict = false;
                    }

                    this.onActive.emit(this.active);
                }
            ));
            this.subscriptions.add(this.eventsService.$click.subscribe((event: MouseEvent) => {
                if (this.elementRef.nativeElement.contains(event.target)) {
                    event.stopPropagation();
                } else {
                    this.resetActive();
                }
            }));
        });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Reset the active control to a null value
     */
    public resetActive(): void {
        if (this.active) {
            this.chromeControlsService.resetActiveControl();
        }
    }

    /**
     * Set the next active control
     */
    public setActive(event: MouseEvent): void {
        if (this.active) {
            this.chromeControlsService.resetActiveControl()
        } else {
            this.chromeControlsService.setActiveControl(this.id);
        }
    }
}
